<template>
  <v-app dark>
    <v-col>
      <ValidationObserver ref="pollValidation"
                          v-slot="{ invalid, passes }">
        <h1 class="mb-6 mt-0">
          Rodina rodičů (nepovinné)
        </h1>

        <p class="mb-6">
          Vyplňte prosím údaje o Vašich rodinných příbuzných (onkologická onemocnění, jiná závažná onemocnění nebo vrozené vývojové vady)
        </p>

        <h2 class="pt-6">
          Rodina matky
        </h2>

        <v-row>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="noInformationMother"
              row>
              <v-radio color="blue lighten-1"
                       label="Chci vyplnit (i částečně)"
                       :value="2" />
              <v-radio color="blue lighten-1"
                       label="Nemám žádné informace"
                       :value="true" />
            </VRadioWithValidation>
          </v-col>
        </v-row>

        <h3>
          Matka matky
        </h3>

        <v-row>
          <v-col
            cols="2">
            <v-text-field
              :disabled="noInformationMother === true"
              v-model="motherFamily.mother.yearBirth"
              label="Rok narození" />
          </v-col>
          <v-col
            cols="6">
            <v-row v-if="motherFamily.mother.sicks.length">
              <v-col>
                <v-chip
                  :disabled="noInformationMother === true"
                  class="ma-2"
                  v-for="(sick, i) in motherFamily.mother.sicks"
                  :key="sick[i]"
                  close
                  @click:close="removeChip(i, 'motherFamily', 'mother')">
                  {{ sick.name }},
                  {{ sick.age }}
                </v-chip>
              </v-col>
            </v-row>
            <v-row class="align-center">
              <v-col
                class="pt-0"
                cols="6">
                <v-text-field
                  :disabled="noInformationMother === true"
                  v-model="motherFamily.mother.adding.name"
                  label="Onemocnění" />
              </v-col>
              <v-col
                class="pt-0"
                cols="4">
                <v-text-field
                  :disabled="noInformationMother === true"
                  v-model="motherFamily.mother.adding.age"
                  label="Věk diagnózy" />
              </v-col>
              <v-col
                class="pt-0"
                cols="2">
                <v-btn :disabled="noInformationMother === true"
                       fab
                       small
                       color="green darken-1 text--white"
                       @click="addSick('motherFamily', 'mother')">
                  <v-icon>add</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="2">
            <VRadioWithValidation
              :disabled="noInformationMother === true"
              :rules="noInformationMother === 2 ? 'required' : ''"
              v-model="motherFamily.mother.alive"
              row
              custom-class="mt-2">
              <v-radio color="blue lighten-1"
                       label="Žije"
                       :value="true" />
              <v-radio color="blue lighten-1"
                       label="Nežije"
                       :value="1" />
            </VRadioWithValidation>
          </v-col>
          <v-col
            cols="2"
            v-if="motherFamily.mother.alive === 1">
            <v-text-field
              :disabled="noInformationMother === true"
              v-model="motherFamily.mother.ageDeath"
              label="Věk úmrtí" />
          </v-col>
        </v-row>

        <h3>
          Otec matky
        </h3>

        <v-row>
          <v-col
            cols="2">
            <v-text-field
              :disabled="noInformationMother === true"
              v-model="motherFamily.father.yearBirth"
              label="Rok narození" />
          </v-col>
          <v-col
            cols="6">
            <v-row v-if="motherFamily.father.sicks.length">
              <v-col>
                <v-chip
                  :disabled="noInformationMother === true"
                  class="ma-2"
                  v-for="(sick, i) in motherFamily.father.sicks"
                  :key="sick[i]"
                  close
                  @click:close="removeChip(i, 'motherFamily', 'father')">
                  {{ sick.name }},
                  {{ sick.age }}
                </v-chip>
              </v-col>
            </v-row>
            <v-row class="align-center">
              <v-col
                class="pt-0"
                cols="6">
                <v-text-field
                  :disabled="noInformationMother === true"
                  v-model="motherFamily.father.adding.name"
                  label="Onemocnění" />
              </v-col>
              <v-col
                class="pt-0"
                cols="4">
                <v-text-field
                  :disabled="noInformationMother === true"
                  v-model="motherFamily.father.adding.age"
                  label="Věk diagnózy" />
              </v-col>
              <v-col
                class="pt-0"
                cols="2">
                <v-btn :disabled="noInformationMother === true"
                       fab
                       small
                       color="green darken-1 text--white"
                       @click="addSick('motherFamily', 'father')">
                  <v-icon>add</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="2">
            <VRadioWithValidation
              :disabled="noInformationMother === true"
              :rules="noInformationMother === 2 ? 'required' : ''"
              v-model="motherFamily.father.alive"
              row
              custom-class="mt-2">
              <v-radio color="blue lighten-1"
                       label="Žije"
                       :value="true" />
              <v-radio color="blue lighten-1"
                       label="Nežije"
                       :value="1" />
            </VRadioWithValidation>
          </v-col>
          <v-col
            cols="2"
            v-if="motherFamily.father.alive === 1">
            <v-text-field
              :disabled="noInformationMother === true"
              v-model="motherFamily.father.ageDeath"
              label="Věk úmrtí" />
          </v-col>
        </v-row>

        <h3>
          Sourozenci matky (nepovinné)
        </h3>

        <v-btn
          :disabled="noInformationMother === true"
          @click="addSibling('motherSiblings')"
          class="mt-4 mb-4"
          color="blue lighten-1 white--text"
          depressed>
          Přidat sourozence
        </v-btn>

        <v-card
          :disabled="noInformationMother === true"
          v-for="(sibling, i) in motherSiblings"
          :key="i + '-motherSiblings'"
          class="pa-3"
          outlined>
          <v-row>
            <v-col
              cols="6">
              <VRadioWithValidation
                :disabled="noInformationMother === true"
                :rules="noInformationMother === 2 ? 'required' : ''"
                v-model="motherSiblings[i].male"
                row
                custom-class="mt-2">
                <v-radio color="blue lighten-1"
                         label="Bratr"
                         :value="true" />
                <v-radio color="blue lighten-1"
                         label="Sestra"
                         :value="1" />
              </VRadioWithValidation>
            </v-col>
            <v-col
              cols="6"
              class="text-right">
              <v-btn
                @click="removeSibling(i, 'motherSiblings')"
                class="ml-auto"
                color="indigo lighten-4"
                depressed>
                Odstranit
              </v-btn>
            </v-col>
            <v-col
              cols="2">
              <v-text-field
                :disabled="noInformationMother === true"
                v-model="motherSiblings[i].yearBirth"
                label="Rok narození" />
            </v-col>
            <v-col
              cols="6">
              <v-row v-if="motherSiblings[i].diseases.length">
                <v-col>
                  <v-chip
                    :disabled="noInformationMother === true"
                    class="ma-2"
                    v-for="(sick, j) in motherSiblings[i].diseases"
                    :key="j"
                    close
                    @click:close="removeSiblingChip(motherSiblings[i], j)">
                    {{ sick.value }},
                    {{ sick.year }}
                  </v-chip>
                </v-col>
              </v-row>
              <v-row class="align-center">
                <v-col
                  class="pt-0"
                  cols="6">
                  <v-text-field
                    :disabled="noInformationMother === true"
                    v-model="motherSiblings[i].addingName"
                    label="Onemocnění" />
                </v-col>
                <v-col
                  class="pt-0"
                  cols="4">
                  <v-text-field
                    :disabled="noInformationMother === true"
                    v-model="motherSiblings[i].addingAge"
                    label="Věk diagnózy" />
                </v-col>
                <v-col
                  class="pt-0"
                  cols="2">
                  <v-btn :disabled="noInformationMother === true"
                         fab
                         small
                         color="green darken-1 text--white"
                         @click="addSickSibling(motherSiblings[i])">
                    <v-icon>add</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="2">
              <VRadioWithValidation
                :disabled="noInformationMother === true"
                :rules="noInformationMother === 2 ? 'required' : ''"
                v-model="motherSiblings[i].alive"
                row
                custom-class="mt-2">
                <v-radio color="blue lighten-1"
                         label="Žije"
                         :value="true" />
                <v-radio color="blue lighten-1"
                         label="Nežije"
                         :value="1" />
              </VRadioWithValidation>
            </v-col>
            <v-col
              cols="2"
              v-if="motherSiblings[i].alive === 1">
              <v-text-field
                :disabled="noInformationMother === true"
                v-model="motherSiblings[i].ageDeath"
                label="Věk úmrtí" />
            </v-col>
          </v-row>
        </v-card>

        <h2 class="mt-12">
          Rodina otce
        </h2>

        <v-row>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="noInformationFather"
              row>
              <v-radio color="blue lighten-1"
                       label="Chci vyplnit (i částečně)"
                       :value="2" />
              <v-radio color="blue lighten-1"
                       label="Nemám žádné informace"
                       :value="true" />
            </VRadioWithValidation>
          </v-col>
        </v-row>

        <h3>
          Matka otce
        </h3>

        <v-row>
          <v-col
            cols="2">
            <v-text-field
              :disabled="noInformationFather === true"
              v-model="fatherFamily.mother.yearBirth"
              label="Rok narození" />
          </v-col>
          <v-col
            cols="6">
            <v-row v-if="fatherFamily.mother.sicks.length">
              <v-col>
                <v-chip
                  :disabled="noInformationFather === true"
                  class="ma-2"
                  v-for="(sick, i) in fatherFamily.mother.sicks"
                  :key="sick[i]"
                  close
                  @click:close="removeChip(i, 'fatherFamily', 'mother')">
                  {{ sick.name }},
                  {{ sick.age }}
                </v-chip>
              </v-col>
            </v-row>
            <v-row class="align-center">
              <v-col
                class="pt-0"
                cols="6">
                <v-text-field
                  :disabled="noInformationFather === true"
                  v-model="fatherFamily.mother.adding.name"
                  label="Onemocnění" />
              </v-col>
              <v-col
                class="pt-0"
                cols="4">
                <v-text-field
                  :disabled="noInformationFather === true"
                  v-model="fatherFamily.mother.adding.age"
                  label="Věk diagnózy" />
              </v-col>
              <v-col
                class="pt-0"
                cols="2">
                <v-btn :disabled="noInformationFather === true"
                       fab
                       small
                       color="green darken-1 text--white"
                       @click="addSick('fatherFamily', 'mother')">
                  <v-icon>add</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="2">
            <VRadioWithValidation
              :rules="noInformationFather === 2 ? 'required' : ''"
              :disabled="noInformationFather === true"
              v-model="fatherFamily.mother.alive"
              row
              custom-class="mt-2">
              <v-radio color="blue lighten-1"
                       label="Žije"
                       :value="true" />
              <v-radio color="blue lighten-1"
                       label="Nežije"
                       :value="1" />
            </VRadioWithValidation>
          </v-col>
          <v-col
            cols="2"
            v-if="fatherFamily.mother.alive === 1">
            <v-text-field
              :disabled="noInformationFather === true"
              v-model="fatherFamily.mother.ageDeath"
              label="Věk úmrtí" />
          </v-col>
        </v-row>

        <h3>
          Otec otce
        </h3>

        <v-row>
          <v-col
            cols="2">
            <v-text-field
              :disabled="noInformationFather === true"
              v-model="fatherFamily.father.yearBirth"
              label="Rok narození" />
          </v-col>
          <v-col
            cols="6">
            <v-row v-if="fatherFamily.father.sicks.length">
              <v-col>
                <v-chip
                  :disabled="noInformationFather === true"
                  class="ma-2"
                  v-for="(sick, i) in fatherFamily.father.sicks"
                  :key="sick[i]"
                  close
                  @click:close="removeChip(i, 'fatherFamily', 'father')">
                  {{ sick.name }},
                  {{ sick.age }}
                </v-chip>
              </v-col>
            </v-row>
            <v-row class="align-center">
              <v-col
                class="pt-0"
                cols="6">
                <v-text-field
                  :disabled="noInformationFather === true"
                  v-model="fatherFamily.father.adding.name"
                  label="Onemocnění" />
              </v-col>
              <v-col
                class="pt-0"
                cols="4">
                <v-text-field
                  :disabled="noInformationFather === true"
                  v-model="fatherFamily.father.adding.age"
                  label="Věk diagnózy" />
              </v-col>
              <v-col
                class="pt-0"
                cols="2">
                <v-btn :disabled="noInformationFather === true"
                       fab
                       small
                       color="green darken-1 text--white"
                       @click="addSick('fatherFamily', 'father')">
                  <v-icon>add</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="2">
            <VRadioWithValidation
              :rules="noInformationFather === 2 ? 'required' : ''"
              :disabled="noInformationFather === true"
              v-model="fatherFamily.father.alive"
              row
              custom-class="mt-2">
              <v-radio color="blue lighten-1"
                       label="Žije"
                       :value="true" />
              <v-radio color="blue lighten-1"
                       label="Nežije"
                       :value="1" />
            </VRadioWithValidation>
          </v-col>
          <v-col
            cols="2"
            v-if="fatherFamily.father.alive === 1">
            <v-text-field
              :disabled="noInformationFather === true"
              v-model="fatherFamily.father.ageDeath"
              label="Věk úmrtí" />
          </v-col>
        </v-row>

        <h3>
          Sourozenci otce (nepovinné)
        </h3>

        <v-btn
          :disabled="noInformationFather === true"
          @click="addSibling('fatherSiblings')"
          class="mt-4 mb-4"
          color="blue lighten-1 white--text"
          depressed>
          Přidat sourozence
        </v-btn>

        <v-card
          :disabled="noInformationFather === true"
          v-for="(sibling, i) in fatherSiblings"
          :key="i"
          class="pa-3"
          outlined>
          <v-row>
            <v-col
              cols="6">
              <VRadioWithValidation
                :rules="noInformationFather === 2 ? 'required' : ''"
                :disabled="noInformationFather === true"
                v-model="fatherSiblings[i].male"
                row
                custom-class="mt-2">
                <v-radio color="blue lighten-1"
                         label="Bratr"
                         :value="true" />
                <v-radio color="blue lighten-1"
                         label="Sestra"
                         :value="1" />
              </VRadioWithValidation>
            </v-col>
            <v-col
              cols="6"
              class="text-right">
              <v-btn
                @click="removeSibling(i, 'fatherSiblings')"
                class="ml-auto"
                color="indigo lighten-4"
                depressed>
                Odstranit
              </v-btn>
            </v-col>
            <v-col
              cols="2">
              <v-text-field
                :disabled="noInformationFather === true"
                v-model="fatherSiblings[i].yearBirth"
                label="Rok narození" />
            </v-col>
            <v-col
              cols="6">
              <v-row v-if="fatherSiblings[i].diseases.length">
                <v-col>
                  <v-chip
                    :disabled="noInformationFather === true"
                    class="ma-2"
                    v-for="(sick, j) in fatherSiblings[i].diseases"
                    :key="j"
                    close
                    @click:close="removeSiblingChip(fatherSiblings[i], j)">
                    {{ sick.value }},
                    {{ sick.year }}
                  </v-chip>
                </v-col>
              </v-row>
              <v-row class="align-center">
                <v-col
                  class="pt-0"
                  cols="6">
                  <v-text-field
                    :disabled="noInformationFather === true"
                    v-model="fatherSiblings[i].addingName"
                    label="Onemocnění" />
                </v-col>
                <v-col
                  class="pt-0"
                  cols="4">
                  <v-text-field
                    :disabled="noInformationFather === true"
                    v-model="fatherSiblings[i].addingAge"
                    label="Věk diagnózy" />
                </v-col>
                <v-col
                  class="pt-0"
                  cols="2">
                  <v-btn :disabled="noInformationFather === true"
                         fab
                         small
                         color="green darken-1 text--white"
                         @click="addSickSibling(fatherSiblings[i])">
                    <v-icon>add</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="2">
              <VRadioWithValidation
                :rules="noInformationFather === 2 ? 'required' : ''"
                :disabled="noInformationFather === true"
                v-model="fatherSiblings[i].alive"
                row
                custom-class="mt-2">
                <v-radio color="blue lighten-1"
                         label="Žije"
                         :value="true" />
                <v-radio color="blue lighten-1"
                         label="Nežije"
                         :value="1" />
              </VRadioWithValidation>
            </v-col>
            <v-col
              v-if="fatherSiblings[i].alive === 1"
              cols="2">
              <v-text-field
                :disabled="noInformationFather === true"
                v-model="fatherSiblings[i].ageDeath"
                label="Věk úmrtí" />
            </v-col>
          </v-row>
        </v-card>
        <v-col
          cols="auto">
          <v-btn @click="submit()"
                 type="submit"
                 x-large
                 depressed
                 height="68px"
                 class="px-12 white--text"
                 color="blue lighten-1">
            Uložit
          </v-btn>
        </v-col>
      </ValidationObserver>
    </v-col>
  </v-app>
</template>

<script>
/* eslint-disable no-new-object */
export default {
  name: 'TheParentsRelations',
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      noInformationMother: null,
      noInformationFather: null,
      motherFamily: {
        mother: {
          name: '',
          yearBirth: '',
          ageDeath: '',
          adding: {
            name: '',
            age: '',
          },
          sicks: [],
          alive: null,
        },
        father: {
          name: '',
          yearBirth: '',
          ageDeath: '',
          adding: {
            name: '',
            age: '',
          },
          sicks: [],
          alive: null,
        }
      },
      fatherFamily: {
        mother: {
          name: '',
          yearBirth: '',
          ageDeath: '',
          adding: {
            name: '',
            age: '',
          },
          sicks: [],
          alive: null,
        },
        father: {
          name: '',
          yearBirth: '',
          ageDeath: '',
          adding: {
            name: '',
            age: '',
          },
          sicks: [],
          alive: null,
        }
      },
      motherSiblings: [],
      fatherSiblings: [],
    };
  },
  computed: {
    siblings() {
      return this.motherSiblings.concat(this.fatherSiblings);
    },
    motherFamilyToSend() {
      let mother = {};
      let father = {};
      mother = {
        yearBirth: this.motherFamily.mother.yearBirth,
        diseaseType: JSON.stringify(this.motherFamily.mother.sicks),
        relationship: 'mother',
        ageDiagnosis: '1',
        alive: this.motherFamily.mother.alive !== 1,
        ageDeath: this.motherFamily.mother.ageDeath
      };
      father = {
        yearBirth: this.motherFamily.father.yearBirth,
        diseaseType: JSON.stringify(this.motherFamily.father.sicks),
        relationship: 'father',
        ageDiagnosis: '1',
        alive: this.motherFamily.father.alive !== 1,
        ageDeath: this.motherFamily.father.ageDeath
      };

      const motherFamily = [];

      if (Object.keys(mother).length !== 0) {
        motherFamily.push(mother);
      }
      if (Object.keys(father).length !== 0) {
        motherFamily.push(father);
      }

      const motherSiblings = JSON.parse(JSON.stringify(this.motherSiblings));
      motherSiblings.forEach((sibling) => {
        if (sibling.alive === 1) {
          sibling.alive = false;
        }
        if (sibling.male === 1) {
          sibling.male = false;
        }
      });

      return new Object({
        mothersFamily: motherFamily,
        mothersSiblings: motherSiblings,
      });
    },
    fatherFamilyToSend() {
      let mother = {};
      let father = {};
      mother = {
        yearBirth: this.fatherFamily.mother.yearBirth,
        diseaseType: JSON.stringify(this.fatherFamily.mother.sicks),
        relationship: 'mother',
        ageDiagnosis: '1',
        alive: this.fatherFamily.mother.alive !== 1,
        ageDeath: this.fatherFamily.mother.ageDeath
      };
      father = {
        yearBirth: this.fatherFamily.father.yearBirth,
        diseaseType: JSON.stringify(this.fatherFamily.father.sicks),
        relationship: 'father',
        ageDiagnosis: '1',
        alive: this.fatherFamily.father.alive !== 1,
        ageDeath: this.fatherFamily.father.ageDeath
      };

      const fatherFamily = [];

      if (Object.keys(mother).length !== 0) {
        fatherFamily.push(mother);
      }
      if (Object.keys(father).length !== 0) {
        fatherFamily.push(father);
      }

      const fatherSiblings = JSON.parse(JSON.stringify(this.fatherSiblings));
      fatherSiblings.forEach((sibling) => {
        if (sibling.alive === 1) {
          sibling.alive = false;
        }
        if (sibling.male === 1) {
          sibling.male = false;
        }
      });

      return new Object({
        fathersFamily: fatherFamily,
        fathersSiblings: fatherSiblings,
      });
    },
    familyToSend() {
      const form = Object.assign(
        this.motherFamilyToSend,
        this.fatherFamilyToSend,
      );
      form.userId = this.$store.state['vue-auth'].user ? this.$store.state['vue-auth'].user.id : '';
      form.noInformationMother = this.noInformationMother !== 2;
      form.noInformationFather = this.noInformationFather !== 2;
      return form;
    }
  },
  methods: {
    addSick(family, parent) {
      if (!this[family][parent].adding.name.length || !this[family][parent].adding.age.length) {
        return;
      }
      this[family][parent].sicks.push({
        name: this[family][parent].adding.name,
        age: this[family][parent].adding.age,
      });

      this[family][parent].adding.name = '';
      this[family][parent].adding.age = '';
    },
    addSickSibling(sibling) {
      if (!sibling.addingName.length || !sibling.addingAge.length) {
        return;
      }
      sibling.diseases.push({
        value: sibling.addingName,
        year: sibling.addingAge,
      });

      sibling.addingName = '';
      sibling.addingAge = '';
    },
    removeChip(index, family, parent) {
      this[family][parent].sicks.splice(index, 1);
    },
    removeSiblingChip(sibling, index) {
      sibling.diseases.splice(index, 1);
    },
    addSibling(parent) {
      this[parent].push({
        fullName: '',
        yearBirth: '',
        diseases: [],
      });
    },
    removeSibling(i, sibling) {
      this[sibling].splice(i, 1);
    },
    async submit() {
      const valid = await this.$refs.pollValidation.validate();

      if (!valid) {
        return false;
      }

      const form = this.familyToSend;
      form.CustomerId = this.id;

      document.getElementById('genscanLogoDiv').scrollIntoView();

      this.axios.put('admin/questionnaires/parentsfamilyanamnesis', form).then((res) => {
        if (res.status === 200) {
          this.$root.$bvToast.toast(this.$t('Questionnaires.SuccessToast.Body'), {
            title: this.$t('Questionnaires.SuccessToast.Title'),
            variant: 'success',
            toaster: 'b-toaster-top-right'
          });
          this.$emit('completed');
        }
      }).catch(() => {
        this.$root.$bvToast.toast(this.$t('Questionnaires.FailureToast.Body'), {
          title: this.$t('Questionnaires.FailureToast.Title'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
      });

      return true;
    }
  },
  created() {
    this.axios.get('admin/questionnaires/parentsfamilyanamnesis', {
      params: {
        CustomerId: this.id
      }
    }).then((response) => {
      const data = response.data.result;

      this.noInformationMother = data.noInformationMother === false ? 2 : true;
      this.noInformationFather = data.noInformationFather === false ? 2 : true;

      const mothersMother = data.mothersFamily.find((parent) => parent.relationship === 'mother');
      const mothersFather = data.mothersFamily.find((parent) => parent.relationship === 'father');

      if (mothersMother) {
        this.$set(this.motherFamily, 'mother', mothersMother);
        this.$set(this.motherFamily.mother, 'alive', mothersMother.alive === false ? 1 : true);
        this.$set(this.motherFamily.mother, 'sicks', []);
        this.$set(this.motherFamily.mother, 'sicks', JSON.parse(mothersMother.diseaseType));
        this.$set(this.motherFamily.mother, 'adding', new Object({
          name: '',
          age: ''
        }));
      }
      if (mothersFather) {
        this.$set(this.motherFamily, 'father', mothersFather);
        this.$set(this.motherFamily.father, 'alive', mothersFather.alive === false ? 1 : true);
        this.$set(this.motherFamily.father, 'sicks', []);
        this.$set(this.motherFamily.father, 'sicks', JSON.parse(mothersFather.diseaseType));
        this.$set(this.motherFamily.father, 'adding', new Object({
          name: '',
          age: ''
        }));
      }

      const fathersMother = data.fathersFamily.find((parent) => parent.relationship === 'mother');
      const fathersFather = data.fathersFamily.find((parent) => parent.relationship === 'father');

      if (fathersMother) {
        this.$set(this.fatherFamily, 'mother', fathersMother);
        this.$set(this.fatherFamily.mother, 'alive', fathersMother.alive === false ? 1 : true);
        this.$set(this.fatherFamily.mother, 'sicks', []);
        this.$set(this.fatherFamily.mother, 'sicks', JSON.parse(fathersMother.diseaseType));
        this.$set(this.fatherFamily.mother, 'adding', new Object({
          name: '',
          age: ''
        }));
      }
      if (fathersFather) {
        this.$set(this.fatherFamily, 'father', fathersFather);
        this.$set(this.fatherFamily.father, 'alive', fathersFather.alive === false ? 1 : true);
        this.$set(this.fatherFamily.father, 'sicks', []);
        this.$set(this.fatherFamily.father, 'sicks', JSON.parse(fathersFather.diseaseType));
        this.$set(this.fatherFamily.father, 'adding', new Object({
          name: '',
          age: ''
        }));
      }

      this.motherSiblings = data.mothersSiblings;
      this.motherSiblings.forEach((sibling) => {
        if (sibling.alive === false) {
          sibling.alive = 1;
        }
        if (sibling.male === false) {
          sibling.male = 1;
        }
      });
      this.fatherSiblings = data.fathersSiblings;
      this.fatherSiblings.forEach((sibling) => {
        if (sibling.alive === false) {
          sibling.alive = 1;
        }
        if (sibling.male === false) {
          sibling.male = 1;
        }
      });
    });
  }
};
</script>
